import Swiper from "swiper";
import { Navigation, Pagination, Autoplay, A11y } from "swiper/modules";

function buildSwiper(element) {
  if(typeof element.Swiper?.destroy !== 'undefined'){
    element.Swiper.destroy();
  }

  const hideIfEmpty = !!parseInt(element.dataset.hideIfEmpty || null, 10);

  if(hideIfEmpty && element.querySelectorAll(".swiper-slide:not(.hidden\\!)").length == 0){
    element.closest('section').classList.add('hidden!');
  }else{
    element.closest('section').classList.remove('hidden!');
  }

  new Swiper(element, {
    modules: [Navigation, Pagination, Autoplay, A11y],
    slidesPerView: 1,
    breakpoints: {
      570: {
        slidesPerView: 2,
        autoHeight: false,
      },
    },
    breakpointsBase: 'container',
    spaceBetween: 40,
    simulateTouch: true,
    watchOverflow: false,
    observeSlideChildren: true,
    autoHeight: element.dataset.autoplay != "1" ? true : false,
    navigation: {
      enabled: element.dataset.navigation == "1",
      prevEl: element.closest(".swiper-parent").querySelector(".swiper-navigation .prev"),
      nextEl: element.closest(".swiper-parent").querySelector(".swiper-navigation .next"),
    },
    pagination: {
      enabled: element.dataset.pagination == "1",
      el: element.closest(".swiper-parent").querySelector(".swiper-pagination"),
      clickable: true,
    },
    loop: element.dataset.loop == "1",
    autoplay:
      element.dataset.autoplay == "1"
      ? {
        delay: parseFloat(element.dataset.autoplayDelay) * 1000
      }
      : false,
  });
}

function buildDynamicContentSwiper() {
  document.querySelectorAll(".featured-menu-items-swiper").forEach((element) => {
    buildSwiper(element);
  });
}

document.addEventListener("DOMContentLoaded", () => {
  buildDynamicContentSwiper();
  document.body.addEventListener('venueChanged', buildDynamicContentSwiper);
});
